import type { Logger } from "@expert/logging";

import { getRootDispatcher } from "@/analytics";
import { getSelectedSessionId } from "@/sdk";

import type { SalesProvider } from "../types";

import { getProvider } from "../utils/updatePrimaryProductSaleProgress";
import { getSalesApiClient } from "./api";

export type ProductEnrollmentStatus = "FAILURE" | "INITIALIZED" | "PENDING" | "SUCCESS";

export type GetProductOfferResponse = {
    enrollmentStatus: ProductEnrollmentStatus;
    productOfferId: string;
};

export const getProductOffer = async (
    logger: Logger,
    productOfferId: string,
    partner: string,
    salesProvider: SalesProvider,
): Promise<GetProductOfferResponse> => {
    const sessionId = getSelectedSessionId();
    const childLogger = logger.child({ module: "getProductOffer", productOfferId, partner, salesProvider });
    try {
        childLogger.info({ productOfferId, partner, salesProvider }, "Fetching product offer");
        const response = await getSalesApiClient()
            .get(`v3/product-offer/${partner}/${productOfferId}/${salesProvider}?sessionId=${sessionId}`, {
                retry: 0,
            })
            .json<GetProductOfferResponse>();
        if (response.enrollmentStatus === "SUCCESS" || response.enrollmentStatus === "FAILURE") {
            void getRootDispatcher().dispatchBusinessEvent(`${getProvider(salesProvider)}EnrollmentEventReceived`, {
                productOfferId: response.productOfferId,
                enrollmentStatus: response.enrollmentStatus,
            });
        }
        return response;
    } catch (error: unknown) {
        childLogger.warn({ error }, "product offer poll failed");
        throw error;
    }
};
